import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  title: 'Arregla tu perfil',
  desc: 'Descarga WhatsApp Business y pon una foto profesional. Tu currículum es tu perfil, debe transmitir orden y responsabilidad.'
}, {
  num: '2',
  title: 'Busca 5 agentes',
  desc: "Entra a grupos de Facebook como 'Realtors en [Tu Ciudad]' y busca a los agentes que publican anuncios constantemente."
}, {
  num: '3',
  title: 'Envía tu propuesta',
  desc: 'Usa el mensaje directo incluido en la guía para ofrecerles filtrar sus mensajes de la semana y agendarles citas.'
}];
export function HowItWorks() {
  return <section className="py-24 bg-navy-light text-white relative overflow-hidden" data-id="element-125">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-126">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full border border-white/20" data-id="element-127"></div>
        <div className="absolute top-1/2 -left-24 w-64 h-64 rounded-full border border-white/20" data-id="element-128"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-130">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-131">
            Tu Primer Día en <span className="text-gold italic" data-id="element-132">3 Pasos</span>
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto text-lg" data-id="element-133">
            No esperes que el trabajo llegue a ti. La guía te enseña exactamente
            cómo dar el primer paso hoy mismo.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-12 max-w-5xl mx-auto relative" data-id="element-134">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-10 left-[15%] right-[15%] h-0.5 bg-navy-dark/50 z-0" data-id="element-135"></div>

          {steps.map((step, index) => <motion.div key={step.num} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-136">
              <div className="w-20 h-20 rounded-full bg-navy border-4 border-navy-light flex items-center justify-center shadow-[0_0_20px_rgba(212,168,83,0.2)] mb-6" data-id="element-137">
                <span className="text-2xl font-bold text-gold" data-id="element-138">{step.num}</span>
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-139">{step.title}</h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-140">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}